"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgBasket(props) {
    return (React.createElement("svg", __assign({ xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 16 16' }, props),
        React.createElement("path", { d: 'M15.3,6.00814H10.8l-1.3-2.9c-.1-.3-.5-.2-.6,0l-.3288.8769a.62663.62663,0,0,0,.0177.4825L9.3,6.00814H6.9l1.8-4c.1025-.2083.1309-.3465-.0562-.5336A2.75117,2.75117,0,0,0,8,1.03674c-.3-.1-.5-.0286-.6.1714l-2.1,4.8H.8a.78874.78874,0,0,0-.8.8v.2a.78874.78874,0,0,0,.8.8H1l1.3,6.7a.56.56,0,0,0,.6.5H13.1a.56.56,0,0,0,.6-.5l1.3-6.7h.2a.78874.78874,0,0,0,.8-.8v-.2a.7594.7594,0,0,0-.7-.8m-9.9,6.7a.47239.47239,0,0,1-.5.5.47239.47239,0,0,1-.5-.5v-3.1a.47239.47239,0,0,1,.5-.5.47239.47239,0,0,1,.5.5v3.1m3.2,0a.5.5,0,0,1-1,0v-3.1a.5.5,0,0,1,1,0v3.1m3.2,0a.5.5,0,0,1-1,0v-3.1a.5.5,0,0,1,1,0v3.1' })));
}
exports.default = SvgBasket;
